var HUYAVIDEO = HUYAVIDEO || {};

HUYAVIDEO.UserId = function () {
  this.lUid = 0;
  this.sGuid = '';
  this.sToken = '';
  this.sHuYaUA = '';
  this.sCookie = '';
  this.iTokenType = 0;
};
HUYAVIDEO.UserId.prototype._clone = function () {
  return new HUYAVIDEO.UserId();
};
HUYAVIDEO.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYAVIDEO.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYAVIDEO.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
};

HUYAVIDEO.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
};

HUYAVIDEO.VideoReqHeader = function () {
  this.userId = new HUYAVIDEO.UserId();
  this.byPass = 'default';
};
HUYAVIDEO.VideoReqHeader.prototype._clone = function () {
  return new HUYAVIDEO.VideoReqHeader();
};
HUYAVIDEO.VideoReqHeader.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYAVIDEO.VideoReqHeader.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYAVIDEO.VideoReqHeader.prototype.writeTo = function (os) {
  os.writeStruct(0, this.userId);
  os.writeString(1, this.byPass);
};

HUYAVIDEO.VideoReqHeader.prototype.readFrom = function (is) {
  this.userId = is.readStruct(0, false, this.userId);
  this.byPass = is.readString(1, false, this.byPass);
};

export default HUYAVIDEO;
